import type { ACF, Page } from 'types';
import React, { memo } from 'react';
import Head from 'next/head';
import { useWordPressContext } from 'contexts/wordpress-provider';

const ProductJson: React.FC<Pick<ACF, 'product' | 'totalMedicalCardPrice'>> =
  memo(({ product, totalMedicalCardPrice }) => {
    const { name, description, imageUrl } = product;
    const { trustpilotNumberReviews, trustpilotRating } = useWordPressContext();

    const details = {
      '@context': 'http://schema.org/',
      '@type': 'Product',
      name,
      description,
      brand: 'Leafwell',
      image: imageUrl?.src,
      aggregateRating: {
        '@type': 'aggregateRating',
        ratingValue: trustpilotRating,
        ratingCount: trustpilotNumberReviews,
        reviewCount: trustpilotNumberReviews,
      },
      offers: {
        '@type': 'Offer',
        availability: 'https://schema.org/InStock',
        price: totalMedicalCardPrice,
        priceCurrency: 'USD',
      },
    };

    return React.createElement(
      Head,
      null,
      React.createElement('script', {
        type: 'application/ld+json',
        dangerouslySetInnerHTML: {
          __html: JSON.stringify(details),
        },
      }),
    );
  });

export default ProductJson;
